/**
@license
Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/

import { MISC } from '../constants/misc'

import {
    UPDATE_PAGE,
    UPDATE_OFFLINE,
    OPEN_SNACKBAR,
    CLOSE_SNACKBAR,
    UPDATE_DRAWER_STATE,
    UPDATE_SELECTED_ITEM,
    ADD_NOTIFICATION,
    SET_NOTIFICATIONS,
    ADD_FIELD_OPTION,
    REMOVE_NOTIFICATION,
    CHANGE_HIDDEN_COLUMNS,
    CHANGE_TABLE_ACTIVE_FLAG,
    ADD_RELATION_CLONE,
    LOGIN,
    LOGOUT,
    ADD_WARNING_ITEM,
    REMOVE_WARNING_ITEM,
    ADD_EDITABLE_ITEM,
    REMOVE_EDITABLE_ITEM,
    UPDATE_LIST,
    UPDATE_ITEM_IN_LIST,
} from '../actions/app.js'

const INITIAL_STATE = {
    page: '',
    offline: false,
    drawerOpened: false,
    snackbarOpened: false,
    selectedItem: {},
    appTitle: '',
    isLoading: false,
    notifications: [],
    hiddenTableColumns: localStorage.getItem('hiddenTableColumns')
        ? JSON.parse(localStorage.getItem('hiddenTableColumns'))
        : {},
    tableActiveFlags: localStorage.getItem('tableActiveFlags')
        ? JSON.parse(localStorage.getItem('tableActiveFlags'))
        : {},
    warningItems: [],
    fieldOptions: {},
    relationClone: null,
    loggedIn: false,
    user: localStorage.getItem(MISC.COGNITO.USER) ? localStorage.getItem(MISC.COGNITO.USER) : null,
    editableItem: null,
    editableRenewal: null,
    tableLists: {},
}

const app = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_PAGE:
            return {
                ...state,
                page: action.page,
            }
        case UPDATE_LIST:
            const newTableLists = state.tableLists
            newTableLists[action.table] = action.list
            return {
                ...state,
                tableLists: newTableLists,
            }
        case UPDATE_ITEM_IN_LIST:
            const newTableList = state.tableLists[action.table]
            if (!newTableList) return state
            const index = newTableList.findIndex((item) => item.id === action.itemId)
            if (index === -1) {
                // not found
                newTableList.push(action.item)
            } else {
                newTableList[index] = action.item
            }
            const tableListsAll = state.tableLists
            tableListsAll[action.table] = newTableList
            return {
                ...state,
                tableLists: tableListsAll,
            }
        case LOGIN:
            localStorage.setItem(MISC.COGNITO.USER, action.user)
            return {
                ...state,
                loggedIn: true,
                user: action.user,
            }
        case LOGOUT:
            return {
                ...state,
                loggedIn: false,
                user: null,
            }
        case UPDATE_SELECTED_ITEM:
            const newItem = {}
            newItem[action.item] = action.value
            return {
                ...state,
                selectedItem: { ...state.selectedItem, ...newItem },
            }
        case ADD_RELATION_CLONE:
            return {
                ...state,
                relationClone: action.relationClone,
            }
        case CHANGE_HIDDEN_COLUMNS:
            const newHidden = { ...state.hiddenTableColumns }
            newHidden[action.tableType] = action.columns
            localStorage.setItem('hiddenTableColumns', JSON.stringify(newHidden))
            return {
                ...state,
                hiddenTableColumns: newHidden,
            }
        case CHANGE_TABLE_ACTIVE_FLAG:
            const newFlags = { ...state.tableActiveFlags }
            newFlags[action.tableType] = action.flag
            localStorage.setItem('tableActiveFlags', JSON.stringify(newFlags))
            return {
                ...state,
                tableActiveFlags: newFlags,
            }
        case ADD_WARNING_ITEM:
            const duplicate = state.warningItems.find(
                (item) =>
                    item.type === action.warningItem.type && item.table === action.warningItem.table
            )
            if (duplicate) return state
            return {
                ...state,
                warningItems: [...state.warningItems, action.warningItem],
            }
        case REMOVE_WARNING_ITEM:
            const newItems = state.warningItems.filter(
                (item) => item.table !== action.table || item.type !== action.warningType
            )
            return {
                ...state,
                warningItems: newItems,
            }
        case ADD_NOTIFICATION:
            return {
                ...state,
                notifications: [...state.notifications, action.notification],
            }
        case SET_NOTIFICATIONS:
            return {
                ...state,
                notifications: action.notifications,
            }
        case REMOVE_NOTIFICATION:
            return {
                ...state,
                notifications: state.notifications.filter((item, index) => {
                    index !== action.index
                }),
            }
        case ADD_FIELD_OPTION:
            return {
                ...state,
                fieldOptions: { ...state.fieldOptions, ...action.fieldOptions },
            }
        case UPDATE_OFFLINE:
            return {
                ...state,
                offline: action.offline,
            }
        case UPDATE_DRAWER_STATE:
            return {
                ...state,
                drawerOpened: action.opened,
            }
        case OPEN_SNACKBAR:
            return {
                ...state,
                snackbarOpened: true,
            }
        case CLOSE_SNACKBAR:
            return {
                ...state,
                snackbarOpened: false,
            }
        case ADD_EDITABLE_ITEM:
            return {
                ...state,
                editableItem: action.editableItem,
            }
        case REMOVE_EDITABLE_ITEM:
            return {
                ...state,
                editableItem: null,
            }
        default:
            return state
    }
}

export default app
